import { createSelector } from '../lib/createSelector';
import { aggregateMetricsByType } from './lib/aggregateMetricsByType';
import resolvePricingCalculatorDefaults from './lib/resolvePricingCalculatorDefaults.js';

export const operationsMetrics = (state) => state.operations.operationsMetrics;
export const companiesWithWorkflows = (state) => state.operations.companiesWithWorkflows;
export const workflowAlarms = (state) => state.operations.workflowAlarms;
export const hubspotCompanyMappings = (state) => state.operations.hubspotCompanyMappings;
export const hubspotCompanyMappingsError = (state) => state.operations.hubspotCompanyMappingsError;
export const pricingCalculatorDefaults = (state) => state.operations.pricingCalculatorDefaults;
export const pricingCalculatorDefaultsError = (state) => state.operations.pricingCalculatorDefaultsError;
// Every calculator field with its saved value, falling back to the shared seed for fields that were
// never saved (first use, or a field added after the last save).
export const resolvedPricingCalculatorDefaults = createSelector(
  //
  'resolvedPricingCalculatorDefaults',
  [pricingCalculatorDefaults],
  (saved) => resolvePricingCalculatorDefaults({ saved: saved?.defaults })
);
export const alarmEnabledWorkflowIds = createSelector(
  //
  'alarmEnabledWorkflowIds',
  [workflowAlarms],
  (alarms) => new Set((alarms || []).map((alarm) => alarm.workflowId))
);
export const operationMetricsWithCompany = createSelector(
  //
  'operationMetricsWithCompany',
  [operationsMetrics, companiesWithWorkflows],
  (metrics, companies) => {
    const byWorkflow = new Map(metrics.map((metric) => [metric.workflowId, metric]));
    const completeMetrics = companies.flatMap((company) => company.workflows.map((workflow) => byWorkflow.get(workflow.id) || { companyId: company.companyId, workflowId: workflow.id, total: 0, error: 0, warn: 0, fail: 0, interrupted: 0, success: 0 }));
    return completeMetrics.map((metric) => {
      const company = companies.find((c) => c.companyId === metric.companyId);
      const workflow = company ? company.workflows.find((w) => w.id === metric.workflowId) : null;
      return {
        ...metric,
        operationsEngineers: Array.isArray(company.operationsEngineers) && company.operationsEngineers.length ? company.operationsEngineers : ['__unassigned'],
        companyName: company ? company.companyName : '',
        workflowName: workflow ? workflow.name : ''
      };
    });
  }
);

export const operationsMetricsByEngineer = createSelector(
  //
  'operationsMetricsByEngineer',
  [operationMetricsWithCompany],
  (metrics) => {
    return aggregateMetricsByType(metrics || [], 'operationsEngineers');
  }
);

export const operationsMetricsByCompany = createSelector(
  'operationsMetricsByCompany',
  [operationMetricsWithCompany, (_, engineerId) => engineerId], //
  (metrics, engineerId) => {
    const filteredMetrics = metrics.filter((metric) => metric.operationsEngineers.includes(engineerId));
    return aggregateMetricsByType(filteredMetrics, 'companyId', ['companyName']);
  }
);
